/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';

export default class MultilingualSettings extends Model {
  @attr('boolean') declare fallbackSearchLocaleEnabled: boolean;
  @attr('string') declare fallbackSearchLocale: string;
}
